/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Site_DisabledInputs */

const en_site_url_error_site_disabled = /** @type {(inputs: Site_Url_Error_Site_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website dissection is temporarily turned off.`)
};

const id_site_url_error_site_disabled = /** @type {(inputs: Site_Url_Error_Site_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitur bedah website sedang dinonaktifkan sementara.`)
};

/**
* | output |
* | --- |
* | "Website dissection is temporarily turned off." |
*
* @param {Site_Url_Error_Site_DisabledInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_site_disabled = /** @type {((inputs?: Site_Url_Error_Site_DisabledInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Site_DisabledInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_site_disabled(inputs)
	return en_site_url_error_site_disabled(inputs)
});